import React, { createContext, useContext, useEffect, useState } from 'react';
import { Empty, ConfigProvider, theme } from 'antd';
import { ThemeContextType } from 'types';
import cs_CZ from 'antd/es/locale/cs_CZ';

const ThemeContext = createContext<ThemeContextType | null>(null);

export const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    const [isDarkMode, setIsDarkMode] = useState(localStorage.getItem('themeMode') === 'dark');
    const [primaryColor, setPrimaryColor] = useState(localStorage.getItem('primaryColor') || '#1677ff');

    useEffect(() => {
        localStorage.setItem('themeMode', isDarkMode ? 'dark' : 'light');
    }, [isDarkMode]);
    useEffect(() => {
        localStorage.setItem('primaryColor', primaryColor);
    }, [primaryColor]);

    const config = {
        cssVar: true,
        algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
            colorPrimary: primaryColor,
            fontFamily: `'Inter', 'Poppins', 'Rubik', sans-serif`,
            headerPaddingBlock: 0,
            headerPaddingInline: 32,
        },
        components: {
            Form: {
                verticalLabelPadding: 0,
                marginLG: 16
            },
            Drawer: {
                paddingLG: 16
            },
            Modal: {
                marginXS: 16,
                paddingLG: 16,
            },
            Card: {
                paddingLG: 16,
            }
        }
    };

    return (
        <ThemeContext.Provider value={{ isDarkMode, primaryColor, setIsDarkMode, setPrimaryColor }}>
            <ConfigProvider locale={cs_CZ} theme={config} renderEmpty={() => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description='Nic co můžeme ukázat...'/>}>
                {children}
            </ConfigProvider>
        </ThemeContext.Provider>
    );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
};
